import useFetchData from '../../../../../hooks/fetchHook';
import { formatQueryDate } from '../../../../../utils/timeUtils';
import { formatSupport } from '../formatters/formatSupport';

export const useGetSupport = ({ searchParams, hasPermission }) => {
  const [
    {
      data = formatSupport({ hasPermission })({}),
      isLoading = true,
      isError,
      error,
    },
    _,
    __,
    refresh,
  ] = useFetchData('office_dashboard/support_ticket_counts', {
    formatter: formatSupport({ hasPermission }),
    params: formatParams(searchParams),
  });

  return { data, isLoading, isError, error, refresh };
};

const formatParams = params => {
  const { TIME_FRAME } = params;

  const from_date = formatQueryDate(TIME_FRAME?.value?.fromDate);
  const to_date = formatQueryDate(TIME_FRAME?.value?.toDate);

  const formattedParams = {
    from_date,
    to_date,
  };

  return formattedParams;
};
